<template>
  <div
    id="disqus_thread"
    class="centreramarkera"
  />
  <!-- <section
    class="comments"
    aria-labelledby="comment"
  >
    <h2 id="comment">
      Comments
    </h2>
    <disqus shortname="your_shortname_disqus" />
  </section> -->
</template>

<script>
  // import { Disqus } from 'vue-disqus'
  import * as disqus from './disqus.js' // eslint-disable-line
  export default {
    name: 'Chat',
    // components: { Disqus, },
    created () {
      disqus.load()
    },
  }
</script>

<style>
.centreramarkera {
    margin: 2em;
}
</style>
